import React, { Component } from 'react';
import { loginActions } from '../../action/loginAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { appVariables } from '../../helpers/appVariables';
import { Helmet } from 'react-helmet';
import { history } from '../../helpers/history';

class NewsLetter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PublishNews: [],
            currentPageNo: 0,
            NumberofRecord: 3,
            totalPage: 0,
            startinx: 0,
            endinx: 6,
            lfilterdt: [],
            IsValidData: false,
        }
    }

    componentDidMount() {
        this.setjsondata();
    }

    FormJsonintoArray(Publish) {
        let NewAr = [];
        let Exchange = [];
        for (let index = 0; index < Publish.length; index = index + 2) {
            for (let j = index; j < index + 2; j++) {
                if (Publish[j]) {
                    Exchange.push(Publish[j]);
                }
            }
            NewAr.push(Exchange);
            Exchange = [];
        }
        this.setState({ PublishNews: NewAr })
    }


    componentDidUpdate(prevState, prevProps) {
        if (this.state.PublishNews && this.state.PublishNews !== prevState.PublishNews && this.state.PublishNews.length != 0 && this.state.IsValidData == false) {
            this.state.IsValidData = true;
            this.setState({ IsValidData: true })
            this.LoadTransactionData()
            // window.allDrawResultPopUp();
        }
    }


    setjsondata = () => {
        try {
            let hbanner = 0;
            let hbanner_old = localStorage.getItem('pressnews');
            if (this.props.appvariables.bVersion) {
                let hbannerVer = this.props.appvariables.bVersion.split("~")
                if (hbannerVer.length > 0) {
                    hbanner = hbannerVer[5];//5
                    localStorage.setItem('pressnews', hbanner);
                }
            }
            if (hbanner_old != hbanner) { // hbanner_old != hbannertrue
                var s = process.env.REACT_APP_CDN_URL + 'web/newsletter.json' + "?V" + hbanner;
                fetch(s).then(response => response.json()).then(data => {
                    localStorage.setItem('NewsLetterData', JSON.stringify(data.NewsLetterData));
                    //this.FormJsonintoArray(data.NewsLetterData)
                    this.setState({ PublishNews: data.NewsLetterData })
                })
            } else {
                let NewsletterDate = JSON.parse(localStorage.getItem('NewsLetterData'));
                //this.FormJsonintoArray(NewsletterDate);
                this.setState({ PublishNews: NewsletterDate })

            }
        }
        catch (ex) {
            console.log("setjsondata => ", ex)
        }
    };


    LoadTransactionData = () => {
        if (this.state.PublishNews && this.state.PublishNews.length > 0) {
            this.setState({ lfilterdt: this.state.PublishNews });
            let ltotpage = Math.trunc(this.state.PublishNews.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(this.state.PublishNews.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }



    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }
    formatDateString = (rawDateStr) => {
        const year = rawDateStr.slice(0, 4);
        const month = rawDateStr.slice(4, 6);
        const day = rawDateStr.slice(6, 8);
        const date = new Date(`${year}-${month}-${day}`);
        const options = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-GB', options);
        return formattedDate;
    };

    render() {
        const { t } = this.props;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : NewsLetter</title>
                    <meta name="description" content="Gulf Ticket NewsLetter" />
                </Helmet>
                }
                
                    <div class="myAccount">
                        <div class="myAccContHead border-none">
                            <h1>{t('lblournews')}</h1>
                            <div class="myAccRhtSearch"><input type="text" placeholder="Search" /></div>
                        </div>
                        <div className="newsLetterCont2">
                            {this.state.PublishNews && this.state.PublishNews.length > 0 && this.state.PublishNews.slice(this.state.startinx, this.state.endinx).map((x, inx) =>
                                <div class="newsLetterLi">
                                    <div class="newsLetterLiImg">
                                        <img src={x.imagPath} alt="News Image" />
                                    </div>

                                    <div class="newsLetterLiLft">
                                        <div>
                                            <img src="./assets/img/icons/calendar.png" />
                                            <span>{this.formatDateString(x.modifyOn)}</span>
                                        </div>
                                        <h4>{x.pressTitle}</h4>
                                        <p>{x.pressUrl}</p>
                                        <a href={x.pressUrl}>Read More</a>
                                    </div>
                                </div>
                            )}
                            {/* <ul>
                                {this.state.PublishNews && this.state.PublishNews.length > 0 && this.state.PublishNews.slice(this.state.startinx, this.state.endinx).map((x, inx) =>
                                    <>
                                        <li key={`be_${inx}`}>
                                            <div className="newsCont" >
                                                <h2>{x.pressTitle}</h2>
                                                <img src={x.imagPath} alt="News Image" />
                                                <a href={x.pressUrl} target="_blank" rel="noopener">{x.pressUrl}</a>
                                            </div>
                                        </li>
                                    </>
                                )}
                            </ul> */}
                        </div>
                    </div>
                    <div class="pagination">
                        <div class="paginationLft">
                            Showing <span>{this.state.PublishNews && this.state.PublishNews.length > 0 ? this.state.currentPageNo + 1 : 0}</span> to <span>{this.state.PublishNews && this.state.PublishNews.length > 0 ? this.state.totalPage + 1 : 0}</span>
                        </div>
                        <div class="paginationLRht">
                            <a className={this.state.currentPageNo == 0 ? "active" : ""}><img src="./assets/img/icons/paginate-1-lft.png" alt="left arrow" onClick={() => this.loadnxtdata("-")} /></a>
                            <a className={this.state.currentPageNo == this.state.totalPage ? "active" : ""}><img src="./assets/img/icons/paginate-1-rht.png" alt="right arrow" onClick={() => { this.loadnxtdata("+") }} /></a>
                        </div>
                    </div>
                    {/*   <div className="pagination">
                        <div className="paginationLft">
                            <button><img src="./assets/img/icons/left-arrow.png" className={this.state.currentPageNo == 0 ? "pagination-inactive" : ""} alt="left arrow" onClick={() => this.loadnxtdata("-")} /></button>
                            <div>
                                <span>{this.state.PublishNews && this.state.PublishNews.length > 0 ? this.state.currentPageNo + 1 : 0}</span>
                                <span>/</span>
                                <span>{this.state.PublishNews && this.state.PublishNews.length > 0 ? this.state.totalPage + 1 : 0}</span>
                            </div>
                            <button><img src="./assets/img/icons/right-arrow.png" className={this.state.currentPageNo == this.state.totalPage ? "pagination-inactive" : ""} alt="right arrow" onClick={() => { this.loadnxtdata("+") }} /></button>
                        </div>
                    </div> */}
                {(!this.state.PublishNews || this.state.PublishNews.length == 0) && <div class="noOrders">
                    <img src="./assets/img/icons/sad.png" />
                    <h3>{t('lblnoorder')}</h3>
                    <p class="margin-bottom-20">{t('lblorderempty')}.</p>
                    <div class="formCont updateBtn">
                        <button onClick={() => { history.push("/") }}>{t('lblBuynow')}</button>
                    </div>
                </div>}
            </>
        )
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    return { user, appvariables };
}
const mapActionToProps = {
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(NewsLetter))